import { render, staticRenderFns } from "./Concentration.vue?vue&type=template&id=f61192e2&scoped=true&"
import script from "./Concentration.vue?vue&type=script&lang=js&"
export * from "./Concentration.vue?vue&type=script&lang=js&"
import style0 from "./Concentration.vue?vue&type=style&index=0&id=f61192e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61192e2",
  null
  
)

export default component.exports